export default {
  padding: '.25rem .5rem',
  backgroundColor: '#cc1616',
  color: '#fff',
  fontSize: '.625rem',
  textTransform: 'uppercase',
}
